import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/** IANA zone for US Pacific (PST/PDT). */
export const PACIFIC_TIMEZONE = "America/Los_Angeles";

export const PACIFIC_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const parseUtcIsoToPacificDayjs = (iso: string): Dayjs =>
  dayjs.utc(iso).tz(PACIFIC_TIMEZONE);

export const pacificDayjsToUtcIso = (value: Dayjs | null): string | null => {
  if (!value) {
    return null;
  }
  return dayjs
    .tz(value.format(PACIFIC_DATETIME_FORMAT), PACIFIC_TIMEZONE)
    .utc()
    .toISOString();
};
